import React from 'react';
import { FormattedMessage } from 'react-intl';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePassword = () => (
  <>
    <h1>
      <FormattedMessage id="changePassword.title" />
    </h1>
    <ChangePasswordForm />
  </>
);

export default ChangePassword;
